export default "__VITE_ASSET__BgX_POvS__"